<template>
  <div class="notfound-page">
    <div class="notfound-card">
      <!-- Illustration -->
      <div class="notfound-illustration">
        <svg width="200" height="140" viewBox="0 0 200 140" fill="none" xmlns="http://www.w3.org/2000/svg">
          <!-- Background shape -->
          <rect x="30" y="20" width="140" height="100" rx="16" fill="#f1f5f9" />
          <!-- 4 -->
          <text x="52" y="92" font-family="Lato, sans-serif" font-size="56" font-weight="800" fill="#cbd5e1">4</text>
          <!-- 0 as a circle/magnifier -->
          <circle cx="100" cy="72" r="24" stroke="#94a3b8" stroke-width="4" fill="none" />
          <line x1="118" y1="90" x2="130" y2="102" stroke="#94a3b8" stroke-width="4" stroke-linecap="round" />
          <!-- Eyes inside magnifier -->
          <circle cx="92" cy="68" r="3" fill="#94a3b8" />
          <circle cx="108" cy="68" r="3" fill="#94a3b8" />
          <!-- Mouth -->
          <path d="M94 78 Q100 74 106 78" stroke="#94a3b8" stroke-width="2" stroke-linecap="round" fill="none" />
          <!-- 4 -->
          <text x="132" y="92" font-family="Lato, sans-serif" font-size="56" font-weight="800" fill="#cbd5e1">4</text>
        </svg>
      </div>

      <!-- Text -->
      <h1 class="notfound-title">Page Not Found</h1>
      <p class="notfound-message">
        The page you're looking for doesn't exist or has been moved.
      </p>

      <!-- Action -->
      <router-link :to="{ name: 'PageGuestHome' }" class="notfound-btn">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="notfound-btn__icon">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
        Back to Home
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({}),
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .notfound-page {
  background-color: var(--app-page);
}

.dark-mode .notfound-card {
  background: var(--app-card);
}

.dark-mode .notfound-title {
  color: var(--app-text);
}

.dark-mode .notfound-message {
  color: var(--app-text-muted);
}

/* >>> end auto-dark <<< */

.notfound-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d8dce2;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 24px;
}

.notfound-card {
  text-align: center;
  background: #fff;
  border-radius: 20px;
  padding: 48px 40px 40px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  max-width: 440px;
  width: 100%;
}

.notfound-illustration {
  margin-bottom: 24px;
}

.notfound-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: #1e293b;
  margin: 0 0 10px;
  letter-spacing: -0.3px;
}

.notfound-message {
  font-size: 0.92rem;
  color: #64748b;
  line-height: 1.6;
  margin: 0 0 32px;
}

.notfound-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  background: #56bde8;
  color: #fff;
  border: none;
  border-radius: 12px;
  font-family: 'Lato', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.15s ease;
}

.notfound-btn:hover {
  background: #3dadd8;
  box-shadow: 0 4px 14px rgba(86, 189, 232, 0.3);
  transform: translateY(-1px);
}

.notfound-btn__icon {
  width: 18px;
  height: 18px;
}

/* Dark mode */
.dark-mode .notfound-page {
  background-color: var(--app-page);
}

.dark-mode .notfound-card {
  background: var(--app-page);
  box-shadow: 0 4px 24px var(--app-shadow-soft);
}

.dark-mode .notfound-illustration rect {
  fill: var(--app-card);
}

.dark-mode .notfound-illustration text {
  fill: var(--app-text-faint);
}

.dark-mode .notfound-illustration circle,
.dark-mode .notfound-illustration line,
.dark-mode .notfound-illustration path {
  stroke: var(--app-text-faint);
}

.dark-mode .notfound-illustration circle[fill="#94a3b8"] {
  fill: var(--app-text-faint);
}

.dark-mode .notfound-title {
  color: var(--app-text);
}

.dark-mode .notfound-message {
  color: var(--app-text-muted);
}

.dark-mode .notfound-btn {
  background: var(--app-accent);
}

.dark-mode .notfound-btn:hover {
  background: var(--app-accent);
}

/* Mobile */
@media (max-width: 599px) {
  .notfound-card {
    padding: 36px 24px 32px;
    border-radius: 16px;
  }

  .notfound-illustration svg {
    width: 160px;
    height: 112px;
  }

  .notfound-title {
    font-size: 1.3rem;
  }

  .notfound-message {
    font-size: 0.85rem;
  }
}
</style>
